var map = {
	"./action-reply-all.svg": "WeKt",
	"./action-reply.svg": "4S3a",
	"./add-square.svg": "vw3J",
	"./alarm-check.svg": "332c",
	"./alarm-off.svg": "DqQq",
	"./alarm-sleep.svg": "e5xf",
	"./alarm.svg": "tUSQ",
	"./alert-circle.svg": "s2Qf",
	"./arrow-down.svg": "g5+0",
	"./arrow-left.svg": "w5/Y",
	"./arrow-nav-left.svg": "w+1Z",
	"./arrow-nav-right.svg": "6X1c",
	"./arrow-right.svg": "MIcY",
	"./arrow-up.svg": "TDVH",
	"./attachment.svg": "3UsL",
	"./audio-file-volume.svg": "i7Js",
	"./award-medal.svg": "iWC4",
	"./bin.svg": "K9bL",
	"./calendar-add.svg": "+Rz9",
	"./calendar-cash.svg": "XGaq",
	"./calendar-clock.svg": "5Oui",
	"./calendar.svg": "ju6w",
	"./check-alternate.svg": "5BOM",
	"./check-circle.svg": "shYZ",
	"./chevron-left.svg": "Qfs4",
	"./chevron-right.svg": "m2IE",
	"./close-alternate.svg": "oGnX",
	"./close.svg": "ouph",
	"./common-file-add.svg": "JpX0",
	"./common-file-text-add.svg": "Z6UZ",
	"./controls-next.svg": "tViR",
	"./conversation-multilingual.svg": "i6TH",
	"./copy-duplicate.svg": "KOsN",
	"./critical-triangle.svg": "sPlN",
	"./dark-mode.svg": "8VMZ",
	"./data-transfer.svg": "M4VM",
	"./database-voice.svg": "8bb3",
	"./database.svg": "G/3Y",
	"./diagram-all-direction-expand.svg": "VC71",
	"./dollar.svg": "FHDk",
	"./download-thick-bottom.svg": "hl1i",
	"./email-action-send.svg": "3wv0",
	"./euro.svg": "2D4V",
	"./expand-less.svg": "GV71",
	"./expand-more.svg": "+XjY",
	"./external-hyperlink.svg": "H1j3",
	"./eye-hide.svg": "DaeY",
	"./eye.svg": "nDup",
	"./facebook.svg": "5x7d",
	"./file-search.svg": "+WhK",
	"./file-text.svg": "ce6r",
	"./flash-off.svg": "RdGU",
	"./flash.svg": "REcD",
	"./folder-add.svg": "Y1iJ",
	"./graph-stats-ascend.svg": "McdE",
	"./headphones-customer-support-human.svg": "+ypD",
	"./headphones.svg": "BvB8",
	"./home.svg": "H8wq",
	"./html.svg": "Fwvj",
	"./information-circle.svg": "HWWK",
	"./instagram.svg": "ER2Y",
	"./keyboard-wireless.svg": "Co3N",
	"./layout-dashboard.svg": "5O9i",
	"./light-mode.svg": "784B",
	"./linkedin.svg": "HkkA",
	"./loading-line.svg": "Aib4",
	"./loading.svg": "17H9",
	"./location-pin.svg": "YR3L",
	"./lock.svg": "3jjL",
	"./login.svg": "MUCq",
	"./logout.svg": "qnxq",
	"./loop-arrow.svg": "3MvK",
	"./menu-expand.svg": "/b5I",
	"./messages-bubble-add.svg": "L1nQ",
	"./messages-bubble-check.svg": "LBJT",
	"./messages-bubble-download.svg": "fxDz",
	"./messages-bubble-forward-all.svg": "T8hD",
	"./messages-bubble-forward.svg": "CKA6",
	"./messages-bubble-heart.svg": "QWAk",
	"./messages-bubble-quotation.svg": "C5Go",
	"./messages-bubble-square-add.svg": "JnMJ",
	"./messages-bubble-text.svg": "zLfg",
	"./messages-bubble-typing.svg": "p5DN",
	"./messages-bubble-upload.svg": "J5ZX",
	"./messages-bubble.svg": "zgYa",
	"./microphone.svg": "wf06",
	"./more-horizontal.svg": "ka1x",
	"./more-vertical.svg": "6lsb",
	"./multiple-actions-add.svg": "203d",
	"./multiple-actions-address.svg": "5yxR",
	"./multiple-actions-upload.svg": "e5IL",
	"./neuronal-network.svg": "JKFQ",
	"./notes-add.svg": "EszB",
	"./paste.svg": "88RB",
	"./pencil.svg": "ptcC",
	"./question-circle.svg": "EOEW",
	"./rating-star-give.svg": "vDXd",
	"./refresh.svg": "XbIc",
	"./remove-circle.svg": "I5sx",
	"./robot.svg": "6TU6",
	"./search.svg": "7hlx",
	"./send-email.svg": "glNV",
	"./settings-cog.svg": "Hrg8",
	"./settings-slider.svg": "044B",
	"./share.svg": "eH8R",
	"./shield-check.svg": "CKqX",
	"./single-man-actions-upload.svg": "Q1nG",
	"./single-man.svg": "qVL3",
	"./single-neutral-actions-add.svg": "65Rb",
	"./social-profile-bubble.svg": "26H3",
	"./speedometer-high.svg": "Pv8p",
	"./speedometer-low.svg": "Lzw/",
	"./syncing.svg": "usnB",
	"./tag.svg": "2vk9",
	"./tags-add.svg": "BdoB",
	"./time-clock-circle.svg": "pY2M",
	"./translate.svg": "J0Bh",
	"./twitter.svg": "OIOF",
	"./unlock.svg": "1rk5",
	"./upload-thick-bottom.svg": "AYqA",
	"./user-signal.svg": "7SKk",
	"./video-player.svg": "4BC6",
	"./voice-id-approved.svg": "EVsz",
	"./voice-id-denied.svg": "4ZVK",
	"./voice-id-smartphone.svg": "0qUy",
	"./voice-id-user.svg": "dXuh",
	"./voice-id.svg": "xZoW",
	"./volume.svg": "xUQo",
	"./youtube.svg": "l9K7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d1mE";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@unbabel/ui/src/icons ^\.\/.*\.svg$
// module id = d1mE
// module chunks = 0 1